import { abyssColors } from '@/theme/colors';
import { Box, Stack, Typography, styled as muiStyled } from '@mui/material';
import { theme } from '@/theme/theme';

export const MediaWrapperContainer = muiStyled(Stack)(() => ({
  width: '100%',
  paddingTop: '1.6rem',
  paddingBottom: '1rem',
  gap: '0.75rem',
}));

export const MediaSectionTitle = muiStyled(Typography)(() => ({
  fontSize: '1.4rem',
  fontWeight: 500,
  color: abyssColors.primary[500],
}));

export const UploadButton = muiStyled(Box)(() => ({
  width: '100%',
  height: '3.2rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.625rem',
  padding: '0 1rem',
  marginTop: '1rem',
  marginBottom: '1rem',
  cursor: 'pointer',
  boxSizing: 'border-box',
  borderRadius: '0.4rem',
  border: `1px solid ${abyssColors.primary[500]}`,
  backgroundColor: 'none',
  transition: 'background-color 120ms ease, border-color 120ms ease, box-shadow 120ms ease',
  '&:hover': {
    backgroundColor: abyssColors.primary[100],
    border: `1px solid ${abyssColors.primary[500]}`,
  },
  '&:focus-visible': {
    outline: `2px solid ${abyssColors.primary[100]}`,
    outlineOffset: '2px',
  },
}));

export const UploadButtonText = muiStyled(Typography)(() => ({
  fontWeight: 600,
  textTransform: 'none',
  fontSize: '1.3rem',
  lineHeight: '1',
  color: abyssColors.primary[600],
}));

export const NotesLabel = muiStyled(Typography)(() => ({
  fontWeight: 500,
  fontSize: '1.2rem',
  color: abyssColors.primary[500],
}));

export const NotesContainer = muiStyled(Box)(() => ({
  width: '100%',
  borderRadius: '0.25rem',
  minHeight: '2.8rem',
  padding: '0.8rem',
  backgroundColor: 'transparent',
  overflow: 'visible',
}));

export const notesTextareaStyles: React.CSSProperties = {
  width: '100%',
  border: 'none',
  outline: 'none',
  resize: 'none',
  fontFamily: 'inherit',
  fontSize: '1.2rem',
  color: abyssColors.primary[500],
  backgroundColor: abyssColors.primary[100],
  borderRadius: '0.25rem',
  lineHeight: '1.2',
  overflow: 'hidden',
  padding: '1.2rem',
  margin: 0,
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
};

export const NotesDisplayText = muiStyled(Typography)(() => ({
  color: abyssColors.primary[500],
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
  fontSize: '1.2rem',
  backgroundColor: 'transparent',
}));
